const initTableOfContents = (sectionElement) => {
  console.log('TOC init', sectionElement);
  const tocContainer = sectionElement.querySelector('.toc-container');
  if (!tocContainer) {
    // TOC is not on this page or not enabled in theme customizer
    return;
  }

  const settingsElement = sectionElement.querySelector('#toc-settings');
  if (!settingsElement) {
    console.error('[TOC] Settings JSON script tag not found.');
    return;
  }
  
  const settings = JSON.parse(settingsElement.textContent);

  if (!settings.enable_toc) {
    return; // Double check, though the container shouldn't be rendered anyway
  }

  const articleContent = sectionElement.querySelector('[data-article-content]');
  if (!articleContent) {
    console.error('[TOC] Article content container with [data-article-content] attribute not found.');
    return;
  }

  const includedHeadings = [];
  if (settings.include_h1) includedHeadings.push('h1');
  if (settings.include_h2) includedHeadings.push('h2');
  if (settings.include_h3) includedHeadings.push('h3');
  if (settings.include_h4) includedHeadings.push('h4');
  if (settings.include_h5) includedHeadings.push('h5');
  if (settings.include_h6) includedHeadings.push('h6');
  
  const selector = includedHeadings.join(', ');
  const headings = articleContent.querySelectorAll(selector);
  console.log('TOC headings', headings);
  const tocListContainer = sectionElement.querySelector('#table-of-contents');

  // Clear previous list if re-initializing
  while (tocListContainer.firstChild) {
    tocListContainer.removeChild(tocListContainer.firstChild);
  }

  if (headings.length === 0) {
    tocContainer.style.display = 'none';
    return;
  }
  
  tocContainer.style.display = ''; // Ensure container is visible if it was hidden before

  const list = document.createElement(settings.toc_list_style === 'numbered' ? 'ol' : 'ul');
  if (settings.toc_list_style === 'none' || settings.toc_list_style === 'bullet') {
    list.style.listStyleType = settings.toc_list_style === 'bullet' ? 'disc' : 'none';
  }

  headings.forEach((heading, index) => {
    const id = `toc-heading-${index}`;
    heading.id = id;

    const listItem = document.createElement('li');
    const link = document.createElement('a');
    
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        const y = target.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
        setTimeout(() => {
          window.scrollTo({ top: y, behavior: 'auto' });
        }, 400);
      }
    });

    if (settings.toc_indent_subheadings) {
      const level = parseInt(heading.tagName.substring(1), 10);
      listItem.classList.add(`indent-${level}`);
    }

    listItem.appendChild(link);
    list.appendChild(listItem);
  });

  // Wrap the list in a container for styling the fade-out effect
  const listContainer = document.createElement('div');
  listContainer.classList.add('toc-list-container');
  listContainer.appendChild(list);
  tocListContainer.appendChild(listContainer);

  // Clear previous button if it exists
  const oldButton = tocContainer.querySelector('.toc-toggle-button');
  if (oldButton) {
      oldButton.remove();
  }

  if (settings.toc_collapsible) {
    const toggleButton = document.createElement('button');
    toggleButton.classList.add('toc-toggle-button');
    tocContainer.appendChild(toggleButton); // Place button at the bottom of the main container

    const allItems = list.querySelectorAll('li');
    // Set initial state based on theme setting
    let isExpanded = !settings.toc_start_collapsed;

    const updateTocView = () => {
      const visibleCount = parseInt(settings.toc_visible_items_count, 10);
      const singleLineHeight = allItems.length > 0 ? allItems[0].offsetHeight + 10 : 28; // 10 is for margin-bottom

      if (allItems.length <= visibleCount) {
        toggleButton.style.display = 'none';
        listContainer.classList.remove('is-collapsed');
        return;
      }

      if (isExpanded) {
        listContainer.classList.remove('is-collapsed');
        listContainer.style.maxHeight = '';
        toggleButton.textContent = settings.toc_button_text_collapse || '一部を表示';
        toggleButton.setAttribute('aria-expanded', 'true');
      } else {
        listContainer.classList.add('is-collapsed');
        listContainer.style.maxHeight = `${visibleCount * singleLineHeight}px`;
        toggleButton.textContent = `${settings.toc_button_text_expand || 'すべて表示'} (${allItems.length}件)`;
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    };

    toggleButton.addEventListener('click', (e) => {
      e.preventDefault();
      isExpanded = !isExpanded;
      updateTocView();
    });
    
    // Run once on init to set the button text correctly
    updateTocView();
  }

  // Handle insertion point
  if (settings.toc_insertion_point === 'before_first_heading' && headings.length > 0) {
    const firstHeading = headings[0];
    const parent = firstHeading.parentNode;
    if (parent) {
      parent.insertBefore(tocContainer, firstHeading);
    }
  }
};

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.article-template').forEach(section => {
    initTableOfContents(section);
  });
});

// Theme editor reload
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.article-template') || event.target.classList.contains('article-template')) {
    initTableOfContents(event.target.querySelector('.article-template') || event.target);
  }
});